import { render, staticRenderFns } from "./SculpturesArticles.vue?vue&type=template&id=427326b8&scoped=true&"
import script from "./SculpturesArticles.vue?vue&type=script&lang=js&"
export * from "./SculpturesArticles.vue?vue&type=script&lang=js&"
import style0 from "./SculpturesArticles.vue?vue&type=style&index=0&id=427326b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427326b8",
  null
  
)

export default component.exports